module.exports = __webpack_public_path__ + "static/img/3-6.ff4084da.png";